import { trackEvent, HeapEvents } from '../../../../services/util/AnalyticsUtil'
import ticketsApi from 'services/api/ticketsApi';
import EmployeeApi from 'services/api/EmployeeApi';

/* Service class used to perform api calls for notes */
class NoteService {

    constructor() {
        this.ticketsApi = ticketsApi.create();
        this.employeeApi = EmployeeApi.create();
    }

    /**
     * Retrieves the notes for this ticket for all users
     * @param {any} ticketId
     * @param {any} offset
     * @param {any} limit
     */
    async getNotes(ticketId, offset, limit) {
        let notes = [];
        if (!offset) offset = 0
        if (!limit) limit = 25
      
        try {
            let response = await this.ticketsApi.getTicketNotes(ticketId);
            if (response && response.status === 200) {
                notes = response.data
            }
            else if (response && response.status !== 200) {
                notes = null
            }
        } catch (ex) {
            console.log(ex)
        }

        return notes
    }

    /**
     * Creates a new note for the ticket
     * @param {any} noteContent
     * @param {any} ticketId
     */
    async createNote(noteContent, ticketId) {
        let note = null        

        try {
            let payload = {                
                ticketId: ticketId,
                messageText: noteContent
            }

            let response = await this.ticketsApi.createTicketNote(payload);
            if (response && response.status === 200) {
                try {
                    trackEvent(HeapEvents.SEND_MESSAGE, ticketId)
                } catch (x) {
                    console.log(x)
                }
                note = response.data
            }
        } catch (ex) {
            console.log(ex)
        }

        return note
    }

    async getNoteAuthor(employeeId) {
        try {
            let response = await this.employeeApi.getEmployeeInfo(employeeId);
            return response
        }
        catch (ex) {
            console.log(ex)
        }
    }
    
}

const noteService = new NoteService();
export default noteService;